<template>
  <div>
    <div class="content">
      <div class="main">
        <div>
          <Row>
            <Col :xs="24" :sm="24" :md="24" :lg="15">
              <Row class="title">
                <h4 :style="{float: 'left'}">项目详情</h4>
                <div :style="{float: 'right'}">
                  <Button @click="$router.go(-1)">返回</Button>
                </div>
              </Row>
              <div class="info-property">
                <dl>
                  <dt>模块名</dt><dd>{{ moduleInfo.name }}</dd>
                </dl>
                <dl>
                  <dt>描述</dt><dd>{{ moduleInfo.description }}</dd>
                </dl>
                <dl>
                  <dt>项目经理</dt>
                  <dd><Tag v-for="item in moduleInfo.masters" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>
                </dl>
                <dl>
                  <dt>产品经理</dt>
                  <dd><Tag v-for="item in moduleInfo.pms" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>
                </dl>
                <dl>
                  <dt>开发人员</dt>
                  <dd><Tag v-for="item in moduleInfo.developers" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>
                </dl>
                <dl>
                  <dt>测试人员</dt>
                  <dd><Tag v-for="item in moduleInfo.tests" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>
                </dl>
                <dl>
                  <dt>运维人员</dt>
                  <dd><Tag v-for="item in moduleInfo.maintain" :key="item.id">{{ item.name ? item.name : item.username }}</Tag></dd>
                </dl>
                <dl>
                  <dt>创建用户</dt><dd v-if="moduleInfo.created_user">{{ moduleInfo.created_user.name ?
                  moduleInfo.created_user.name : moduleInfo.created_user.username }}</dd>
                </dl>
                <dl>
                  <dt>创建时间</dt><dd>{{ moment(moduleInfo.created_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <dl>
                  <dt>最后修改时间</dt><dd>{{ moment(moduleInfo.updated_at).format('YYYY-MM-DD HH:mm:ss') }}</dd>
                </dl>
                <div v-if="moduleInfo.deleted">
                  <dl>
                    <dt>状态</dt><dd><span :style="{color: 'red'}">已删除</span></dd>
                  </dl>
                  <dl>
                    <dt>删除时间</dt><dd><span :style="{color: 'red'}">{{ moment(moduleInfo.deleted_at).format('YYYY-MM-DD HH:mm:ss') }}</span></dd>
                  </dl>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { detailModule, getModuleDevelopments } from '@/api/workflow/project'
export default {
  name: 'detail',
  data () {
    return {
      moduleInfo: {},
      developDeploymentInfo: {},
      testDeploymentInfo: {},
      productDeploymentInfo: {},
      moment: moment
    }
  },
  created: function () {
    this.init()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  methods: {
    // 初始化
    init () {
      this.getModuleData()
      this.getModuleDevelopmentInfo()
    },
    // 获取模块信息
    getModuleData () {
      detailModule(this.$route.params.id).then(res => {
        this.moduleInfo = res.data
      }).catch(res => {

      })
    },
    // 获取模块的所有部署环境信息
    getModuleDevelopmentInfo () {
      getModuleDevelopments(this.$route.params.id).then(res => {
        if (res.data.develop) {
          this.developDeploymentInfo = res.data.develop
          this.developDeploymentInfo.have = true
        }
        if (res.data.test) {
          this.testDeploymentInfo = res.data.test
          this.testDeploymentInfo.have = true
        }
        if (res.data.product) {
          this.productDeploymentInfo = res.data.product
          this.productDeploymentInfo.have = true
        }
      }).catch(res => {

      })
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
</style>
